<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value=0 disabled selected) {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.value") {{ $t(option.text) }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: 0
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [
      {
        value: "CYCLE",
        text: "ui.auto_cycle"
      },
      {
        value: "ALL",
        text: "ui.auto_all"
      }
    ]
  }),
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
